import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useDrop } from '../hooks/useDrop';

interface Props extends ChakraV3.StackProps {
  onFilesChange: (files: File[]) => void;
}

export const FileUploadDropZone = (props: React.PropsWithChildren<Props>) => {
  const { onFilesChange, ...rest } = props;

  const state = useDrop({
    onFiles: (files) => onFilesChange(files),
  });

  return (
    <ChakraV3.Stack
      display={state.over ? 'block' : 'none'}
      position='fixed'
      width='100%'
      height='100%'
      left='0'
      top='0'
      boxSizing='border-box'
      zIndex='99999'
      background='rgba(0, 0, 255, 0.1)'
      borderWidth='11px'
      borderStyle='dashed'
      borderColor='purple.400'
      {...rest}
    />
  );
};
